var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'ks-videoeditor-split-' + _vm.direction,on:{"mousedown":function($event){$event.preventDefault();return _vm.start.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }